import i18n from '@/lang/i18n'
import { ConfigurationAutomaticPreformattedByOntologyResponse } from '@/modules/configurationModule/detail/automation/preformatted/services/configuration-preformatted.dto'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { preformattedConfigurationServices } from '@/modules/configurationModule/detail/automation/preformatted/services/configuration-preformatted.service'
import { store } from '@/store/store'

export const columnsDefTextAutomationPreformattedGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            colId: 'sampleType.description',
            field: 'sampleType',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : ''
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.topographicCode'),
            colId: 'topographicCode.description',
            field: 'topographicCode',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : ''
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.procedures'),
            colId: 'procedure.description',
            field: 'procedure',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : ''
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.mostLikelyDiagnoses'),
            colId: 'mostLikelyMorphologicCode.description',
            field: 'mostLikelyMorphologicCode',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : ''
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.preformated', 2),
            field: 'preformatted.title',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        }
    ]

export interface AutomationPreformattedGridState extends CrudModelPaginatorLaboratory<ConfigurationAutomaticPreformattedByOntologyResponse> {
    labId: number
}
export const initialAutomationPreformattedGridState =
    (): AutomationPreformattedGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.preformatted',
        columnsDef: columnsDefTextAutomationPreformattedGrid(),
        datasource: new PaginatorLaboratoryDatasource(preformattedConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
